import { auditReports } from '@mi-front/api-clients';
import { toDateTimeStr } from '@mi-front/core';
import { Grid, Stack } from '@mui/material';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { LDateTime } from '../../../../../../../components/date/LDateTime';
import { AodTriggerType } from '../../../components/AodTriggerType';
import { aodRoutes } from '../../../routing/routes';
import { InfoM } from '../../aod-rule-view/components/InfoM';
import { useAodFactory } from '../../aod-rules-add/custom/AodFactory';
import { AodRunStatusInfo } from './AodRunStatusInfo';

interface AodRunInfoProps {
  run: auditReports.AodRun;
}

export function AodRunInfo({ run }: AodRunInfoProps) {
  const { formatMessage } = useIntl();
  const {
    views: { RunActions },
  } = useAodFactory(run.rule.reportType);

  const scheduledDatetime = run.scheduledDatetime || run.datetime;

  return (
    <Stack spacing={2}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={3}>
          <InfoM
            label={formatMessage({
              id: 'audit.aod.runs.field.ruleName',
              defaultMessage: 'Regla',
            })}
          >
            <Link to={aodRoutes.ruleView.gen(run.rule.id)}>{run.rule.name}</Link>
          </InfoM>
        </Grid>
        <Grid item xs={12} md={4}>
          <InfoM
            label={formatMessage({
              id: 'audit.aod.runs.field.runAt',
              defaultMessage: 'Ejecutada',
            })}
          >
            <LDateTime value={toDateTimeStr(scheduledDatetime!)} showRelative />
          </InfoM>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        {run.order && (
          <Grid item xs={12} md={2}>
            <InfoM
              label={formatMessage({
                id: 'audit.aod.runs.field.order',
                defaultMessage: 'Orden',
              })}
            >
              {run.order}
            </InfoM>
          </Grid>
        )}

        <Grid item xs={12} md={2}>
          <InfoM
            label={formatMessage({
              id: 'audit.aod.runs.field.type',
              defaultMessage: 'Tipo',
            })}
          >
            <AodTriggerType type={run.type} size="small" />
          </InfoM>
        </Grid>

        {run.interval && (
          <Grid item xs={12} md={6}>
            <InfoM
              label={formatMessage({
                id: 'audit.aod.runs.field.interval',
                defaultMessage: 'Intervalo',
              })}
            >
              <LDateTime value={run.interval.split('/')[0]} /> -{' '}
              <LDateTime value={run.interval.split('/')[1]} />
            </InfoM>
          </Grid>
        )}
      </Grid>
      <Grid container spacing={3}>
        <AodRunStatusInfo run={run} />
      </Grid>
      <Grid container spacing={3}>
        {run.description && (
          <Grid item xs={12}>
            <InfoM
              label={formatMessage({
                id: 'audit.aod.runs.field.description',
                defaultMessage: 'Descripción',
              })}
            >
              {run.description}
            </InfoM>
          </Grid>
        )}

        {RunActions && (
          <Grid item xs={12}>
            <InfoM
              label={formatMessage({
                id: 'audit.aod.runs.field.actions',
                defaultMessage: 'Acciones',
              })}
            >
              <RunActions run={run} display="long" />
            </InfoM>
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}
